import { post } from './http';

export const search = async (phrase, type) =>
  await post(type ? `/api/${type}/search` : '/api/search', phrase, { headers: { 'Content-Type': 'text/plain' } });